import React from 'react';
import Icon from './wedge.svg';

const WedgeIcon = ({color='white', className=''}) => {
	return <div className={`${className} lg:w-[18px] lg:h-[18px] sm:w-[14px] sm:h-[14px] w-[12px] h-[12px]`}>
		<Icon height={'100%'} width={'100%'} color={color} aria-hidden={true} />
	</div>
};

export default WedgeIcon;
